<template>
    <v-app>
        <mainMenu></mainMenu>
        <v-container>
            <v-card>
                <v-card-text>
                    <h1>General Ledger</h1>
                    <!-- <v-btn @click="test"></v-btn> -->
                    <hr>
                    <!-- Header Gl -->
                    <div>

                        <!-- Select glType -->
                        <v-layout>
                            <v-flex xs12 text-xs-right my-4><h3>Gl no:</h3></v-flex>
                            <v-flex xs2 pa-1>
                                <v-text-field v-model="glNo" readonly  tabindex="-1"></v-text-field>
                            </v-flex>
                        </v-layout>

                        <!-- Select rv date -->
                        <v-layout justify-end>
                            <v-flex xs2>
                                <v-menu v-model="menuGlDate" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition"
                                offset-y full-width min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-model="date" label="Date:" prepend-icon="event" v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="date" @input="menuGlDate = false"></v-date-picker>
                                </v-menu>
                                <!-- <v-text-field v-model="date" label="Date:" prepend-icon="event"></v-text-field> -->
                            </v-flex>
                        </v-layout>

                        <!-- Select ref no -->
                        <v-layout>
                            <v-flex xs12 text-xs-right my-4><h3>Ref no:</h3></v-flex>
                            <v-flex xs2 pa-1>
                                <v-text-field v-model="refNo" readonly tabindex="-1"></v-text-field>
                            </v-flex>
                        </v-layout>
                    </div>

                    <!-- Input Description -->
                    <v-layout>
                        <v-flex xs4 text-xs-right my-3><h3>Description:</h3></v-flex>
                        <v-flex xs4 pa-1 px-2>
                            <v-text-field v-model="desc" single-line solo ref="desc"></v-text-field>
                        </v-flex>
                    </v-layout>

                    <!-- RV detail -->
                    <div v-if="showRV">
                        <!-- Header account detail -->
                        <hr>
                        <v-layout ma-2>
                            <v-flex text-xs-center pr-2><h4>No.</h4></v-flex>
                            <v-flex xs2 pl-1><h4>Acc code</h4></v-flex>
                            <v-flex xs3 pl-1><h4>Acc name</h4></v-flex>
                            <v-flex xs3 text-xs-right><h4>Debit</h4></v-flex>
                            <v-flex xs3 text-xs-right><h4>Credit</h4></v-flex>
                            <v-flex xs2 text-xs-center><h4>Remark</h4></v-flex>
                            <v-flex xs2></v-flex>
                        </v-layout>
                        <hr>

                        <!-- Account detail -->
                        <v-layout v-for="(item,i) in detailAcc" :key="i" collapse>
                            <v-flex my-3 pl-3 pr-3 pa-1 text-xs-center><font size=4>{{i+1}}</font></v-flex>
                            <v-flex xs2 pr-2>
                                <v-text-field v-model="item.accId" ref="focusAccId" @keypress.enter="searchAcc(item,i)"></v-text-field>
                            </v-flex>
                            <v-flex xs3>
                                <v-text-field v-model="item.accName" readonly tabindex="-1"></v-text-field>
                            </v-flex>
                            <v-flex xs3 my-3 pa-2 ml-2>
                                <font size=3>
                                    <vue-numeric separator="," :precision="2" v-model="item.debit" class="numeric" @blur="changeDebit(item)"></vue-numeric>
                                </font>
                            </v-flex>
                            <v-flex xs3 my-3 pa-2>
                                <font size=3>
                                    <vue-numeric separator="," :precision="2" v-model="item.credit" class="numeric" @blur="changeCredit(item)"></vue-numeric>
                                </font>
                            </v-flex>
                            <v-flex xs2>
                                <v-text-field v-model="item.remark" ref="accRemark"></v-text-field>
                            </v-flex>
                            <v-flex xs2 text-xs-center my-2>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn fab small color="primary" @click="addDetail(item)" v-on="on"><v-icon dark>add</v-icon></v-btn>
                                    </template>
                                    <span>Add new general ledger</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn fab small color="error" @click="delDetail(item)" tabindex="-1" v-on="on"><v-icon dark>remove</v-icon></v-btn>
                                    </template>
                                    <span>Delete general ledger</span>
                                </v-tooltip>
                            </v-flex>
                        </v-layout>

                        <!-- Show account info from the search in database -->
                        <v-dialog v-model="dialogAcc" max-width="600px">
                            <v-card>
                                <v-card-text>
                                    <v-data-table :headers="headers" :items="chartAccount" class="elevation-1" v-bind:pagination.sync="pagination">
                                        <template v-slot:items="props">
                                            <td>{{props.item.accId}}</td>
                                            <td>{{props.item.accName}}</td>
                                            <td class="justify-center layout px-0">
                                                <v-tooltip right>
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon class="mr-1" @click="selectAcc(props.item)" v-on="on">check_circle_outline</v-icon>
                                                    </template>
                                                    <span>Choose this general ledger account number</span>
                                                </v-tooltip>
                                            </td>
                                        </template>
                                    </v-data-table>
                                </v-card-text>
                            </v-card>
                        </v-dialog>
                        <hr>

                        <!-- Display sum debit and credit  -->
                        <v-layout>
                            <v-flex my-3 pl-3 pr-3 pa-1 text-xs-center></v-flex>
                            <v-flex xs2 pr-2></v-flex>
                            <v-flex xs3></v-flex>
                            <v-flex xs3 my-3 pa-2 ml-4 pl-0>
                                <font size=3>
                                    <vue-numeric separator="," :precision="2" :value="sumDebit" class="sumNumeric" disabled></vue-numeric>
                                </font>
                            </v-flex>
                            <v-flex xs3 my-3 pa-2>
                                <font size=3>
                                    <vue-numeric separator="," :precision="2" :value="sumCredit" class="sumNumeric" disabled></vue-numeric>
                                </font>
                            </v-flex>
                            <v-flex xs2></v-flex>
                            <v-flex xs2></v-flex>
                        </v-layout>
                    </div>
                    <hr>
                    <br>
                    <!-- Button add gl and clear web page -->
                    <v-layout>
                        <v-flex text-xs-center>
                            <v-btn @click="addGl()">
                                <v-icon dark>save</v-icon>
                                Save
                            </v-btn>
                            <v-btn @click="cancelGl()">
                                <v-icon dark>clear</v-icon>
                                Cancel
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-container>
    </v-app>
</template>
<script>
import {db} from '@/firebase'
import VueNumeric from 'vue-numeric'
import mainMenu from '@/components/mainMenu.vue'
export default {
    components: {
        VueNumeric,
        mainMenu
    },
    data(){
        return{
            menuGlDate: false,
            showRV: false,
            idCashbook: this.$route.query.id,
            glNo: '',
            subTime: new Date().toTimeString().substr(0,8),
            date: this.$route.query.date.substr(0,10),

            type: this.$route.query.type,
            refNo: this.$route.query.refNo,
            rvNo: '',
            desc: this.$route.query.desc,
            payMent: this.$route.query.payMent,
            detailAcc: [],
            dialogAcc: false,
            chartAccount: [],
            headers: [
                { text: 'Account code', align: 'left', value: 'accId' },
                { text: 'Account name', sortable: false, align: 'left' },
                { text: '', sortable: false, align: 'left' }
            ],
            pagination: {'sortBy': 'accId'},
            Amt: this.$route.query.Amt*1,
            disc: this.$route.query.disc*1,
            custCode: this.$route.query.custCode
        }
    },
    methods:{

        test(){
            let year = "2018"
            let app = this
            let month = new Date(this.date).toISOString().substr(5,2) * 1
            let docAcc = db.collection("accBalance").doc(year)
            return db.runTransaction((transaction)=> {
                return transaction.get(docAcc).then((Doc)=> {
                    if (!Doc.exists) {
                        throw "Document does not exist!"
                    }
                    else{
                        let result = []
                        app.detailAcc.reduce((res,value)=>{
                            if(!res[value.accId]){
                                res[value.accId] = { accId: value.accId, debit: 0, credit: 0}
                                result.push(res[value.accId])
                            }
                            res[value.accId].debit += value.debit
                            res[value.accId].credit += value.credit
                            return res
                        }, {})
                        result.forEach(rec=>{
                            let docAccId = Doc.data()[rec.accId]
                            for(let i = month;i <= 12;i++){
                                docAccId[(i<10? '0':'') + i] += rec.debit
                                docAccId[(i<10? '0':'') + i] -= rec.credit
                                transaction.update(docAcc, {
                                    [rec.accId]: docAccId
                                })
                            }
                            docAccId["debit"] += rec.debit
                            docAccId["credit"] += rec.credit
                            transaction.update(docAcc, {
                                [rec.accId]: docAccId
                            })
                        })
                    }
                })
            })
        },

        // Change credit value = 0 when debit value > 0
        changeDebit(item){
            if(item.debit > 0){
                item.credit = 0
            }
        },

        // Change debit value = 0 when credit value > 0
        changeCredit(item){
            if(item.credit > 0){
                item.debit = 0
            }
        },

        // 
        searchAccRV(){
            db.collection("chartAccount").where("accName", "==", this.payMent).get()
            .then(snapshot=>{
                this.detailAcc = []
                snapshot.forEach(doc=>{
                    let accId = doc.data().accId
                    let accName = doc.data().accName
                    let debit = this.Amt
                    // let debit = (this.Amt - this.disc) - this.disc
                    let remark = ''
                    this.detailAcc.push({accId: accId, accName: accName, debit: debit, remark: remark})
                    if(this.type == "SO-"){
                        db.collection("chartAccount").where("accId", "==", "214101").get()
                        .then(snapshotAcc=>{
                            snapshotAcc.forEach(result=>{
                                let accId = result.data().accId
                                let accName = result.data().accName
                                let credit = this.Amt
                                let remark = ''
                                this.detailAcc.push({accId: accId, accName: accName, credit: credit, remark: remark})
                            })
                            this.showRV = true
                        })
                    }
                    else if(this.type == "INV-"){
                        db.collection("chartAccount").where("accId", "==", "112001").get()
                        .then(snapshotAcc=>{
                            snapshotAcc.forEach(result=>{
                                let accId = result.data().accId
                                let accName = result.data().accName
                                let credit = this.Amt
                                let remark = ''
                                this.detailAcc.push({accId: accId, accName: accName, credit: credit, remark: remark})
                            })
                            this.showRV = true
                        })
                    }
                    else{
                        db.collection("chartAccount").where("accId", "==", "214101").get()
                        .then(snapshotAcc=>{
                            snapshotAcc.forEach(result=>{
                                let accId = result.data().accId
                                let accName = result.data().accName
                                let credit = this.Amt
                                let remark = ''
                                this.detailAcc.push({accId: accId, accName: accName, credit: credit, remark: remark})
                            })
                            this.showRV = true
                        })
                    }
                })
            })
        },

        // Show account info from the search in the database
        searchAcc(item,index){
            let app = this
            if(item.accId == ''){
                alert("Please input Account code.")
                this.$refs.focusAccId.focus()
            }
            else{
                db.collection("chartAccount").orderBy("accId").startAt(item.accId).endAt(item.accId + "\uf8ff").get()
                .then(querySnapshot=>{
                    app.chartAccount = []
                    querySnapshot.forEach(doc=>{
                        let searchDoc = doc.data()
                        app.chartAccount.push(searchDoc)
                    })
                    if(app.chartAccount.length == 0){
                        app.dialogAcc = false
                        alert("This account code is not in the system......")
                        app.chartAccount = []
                    }
                    else{
                        app.dialogAcc = true
                        app.detailAccCurPos = index
                    }
                })
            }
        },

        // Select data from the search in database
        selectAcc(item) {
            this.detailAcc[this.detailAccCurPos].accId = item.accId
            this.detailAcc[this.detailAccCurPos].accName = item.accName
            this.dialogAcc = false
        },

        // Add detail in new line
        addDetail(item){
            let i = this.detailAcc.length - 1
            if(item.accId == ''){
                alert("Please input acc code or delete line no." + (i+1))
                this.$nextTick(()=>{
                    let input = this.$refs.focusAccId[i]
                    input.focus()
                })
            }
            else if(item.debit || item.credit > 0){
                // db.collection("chartAccount").where("id", "==", item.id).get()
                // .then(doc=>{
                //     console.log(doc.data())
                // })
                this.detailAcc.push({debit: 0, credit: 0, remark: ''})
                this.$nextTick(() => {
                    let i = this.detailAcc.length - 1
                    let input = this.$refs.focusAccId[i]
                    input.focus()
                })
            }
            else{
                alert("Please input debit or credit no." + (i+1))
            }
        },

        // Delete the selected account
        delDetail(item){
            this.detailAcc.splice(this.detailAcc.findIndex(detail=>detail==item),1)
        },

        // Add gl in database
        addGl(){
            let app = this
            let year = new Date().toISOString().substr(0,4)
            let i = this.detailAcc.length - 1
            let DocRef = db.collection("counter").doc(year)
            db.collection("generalLedger").where("glNo", "==", this.glNo).get()
            .then(querySnapshot=>{
                app.checkGl = []
                querySnapshot.forEach(doc=>{
                    let curDoc = doc.data().glNo
                    app.checkGl.push(curDoc)
                })
                if(app.checkGl.length >= 1){
                    alert("This order no is already in the system.\nPlease try again.")
                    app.getRvNo()
                }
                else if(app.detailAcc[i].debit || app.detailAcc[i].credit > 0){
                    if(app.sumDebit !== app.sumCredit){
                        alert("Please check again.\nDebit and credit must be equal.")
                    }
                    else{
                        db.runTransaction((transaction)=>{
                            return transaction.get(DocRef).then((Doc)=>{
                                if (!Doc.exists) {
                                    throw "Document does not exist!"
                                }

                                let newGlNo = Doc.data().rv + 1
                                transaction.update(DocRef, { 
                                    rv: newGlNo
                                })
                            })
                        })
                        .then(()=>{

                            // add data in generalLedger
                            let batch = db.batch()
                            app.detailAcc.forEach(objAcc=>{
                                batch.set(db.collection("generalLedger").doc(), {
                                    custCode: app.custCode,
                                    glNo: app.glNo,
                                    glDate: app.date,
                                    refNo: app.refNo,
                                    desc: app.desc,
                                    accId: objAcc.accId,
                                    accName: objAcc.accName,
                                    debit: objAcc.debit,
                                    credit: objAcc.credit,
                                    remark: objAcc.remark
                                })
                            })
                            batch.update(db.collection("cashReceiBook").doc(app.idCashbook), {
                                // date: app.date + " " + app.subTime,
                                rvNo: app.glNo
                            })
                            batch.commit().then(() => {
                                alert("successfully.....")
                                app.cancelGl()
                            })
                            .catch((error) => {
                                console.log(error)
                                alert("failed.....")
                            })
                        })
                        .catch((error)=>{
                            console.log("Transaction failed: ", error)
                        })
                    }
                }
                else{
                    alert("Please input debit or credit no." + (i+1))
                }
            })
        },

        // Cancel gl
        cancelGl(){
            // this.glNo = ''
            // this.glDate = new Date().toISOString().substr(0,10)
            // this.refNo = ''
            // this.desc = ''
            // this.showRV = false
            // this.detailAcc = []
            window.close()
        },

        searchRefId(){
            db.collection("cashReceiBook").where("refNo", "==", this.refNo).where("date", "==", this.$route.query.date)
            .where("Amt", "==", this.$route.query.Amt*1).get()
            .then(querySnapshot=> {
                // let docIdCashbook = querySnapshot.docs[0].id
                // this.idCashbook = docIdCashbook
                querySnapshot.forEach(doc=>{
                    this.custCode = doc.data().custCode
                })
            })
        },

        getRvNo(){
            let year = new Date().toISOString().substr(0,4)
            let subYear = year.substr(2,2)
            db.collection("counter").doc(year).get()
            .then((doc)=> {
                let typeDoc = doc.data().rv + 1
                if (typeDoc<=999999){ 
                    typeDoc = ("00000"+typeDoc).slice(-4)
                }
                this.glNo = "RV" + subYear + typeDoc
            })
        }
    },
    computed:{
        sumDebit(){
            return this.detailAcc.reduce((sum,item) => sum+(item.debit),0)
        },
        sumCredit(){
            return this.detailAcc.reduce((sum,item) => sum+(item.credit),0)
        }
    },
    mounted(){
        // console.log(this.idCashbook)
        this.getRvNo()
        this.searchAccRV()
        // this.searchRefId()
    }
}
</script>
<style scoped>
table {
  border-collapse: collapse;
  width: 100%;
}
.collapse:nth-child(even){
    background-color: #dddddd;
}
.numeric{
    text-align: right;
    width: 100%;
    border-bottom: 1px solid gray;
    /* padding: 0%; */
}
.sumNumeric{
    text-align: right;
    width: 100%;
    border-top: 1px solid black;
    border-left: 1px solid black;
    border-right: 1px solid black;
    border-bottom: 1px solid black;
    padding: 2%;

}
</style>
